"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHART_COLORS = void 0;
var CHART_COLORS = {
    good: "#0ca30c",
    warning: "#fab219",
    critical: "#d03b3b",
    neutral: "#c3c2b7",
    blue: "#2a78d6",
    green: "#008300",
    magenta: "#e87ba4",
    yellow: "#eda100",
    aqua: "#1baf7a",
    orange: "#eb6834",
};
exports.CHART_COLORS = CHART_COLORS;
